import {Component, OnInit} from '@angular/core';
import {AppointmentModel} from "../../../core/models/appointment.model";
import {ActivatedRoute, Router} from "@angular/router";
import {LangChangeEvent, TranslateModule, TranslateService} from "@ngx-translate/core";
import {MatIcon} from '@angular/material/icon';
import {MatAnchor, MatButton} from '@angular/material/button';
import {DatePipe, NgIf} from '@angular/common';
import {MatCard, MatCardActions, MatCardContent} from '@angular/material/card';
import {HeadlineWithIconComponent} from "../../../shared/components/headline-with-icon/headline-with-icon.component";
import {AppointmentDetailsComponent} from "../../components/appointment-details/appointment-details.component";
import {PreventDoubleClickDirective} from "../../../shared/directives/prevent-doublic-click-directive";
import {AppointmentService} from "../../services/appointment.service";
import {IconTextComponent} from "../../../shared/components/icon-text/icon-text.component";
import {EmbedModeService} from "../../services/embed-mode.service";
import {UrlTreeHelper} from "../../../core/services/url-tree-helper";
import {ViessmannHomeBannerComponent} from "../../components/viessmann-home-banner/viessmann-home-banner.component";
import {SettingsModel} from "../../../core/models/settings.model";
import {
  ButtonHeatingSystemsOverviewComponent
} from "../../components/button-heating-systems-overview/button-heating-systems-overview.component";

@Component({
  selector: 'processed',
  templateUrl: './processed.component.html',
  styleUrls: ['./processed.component.scss'],
  standalone: true,
  imports: [MatCard, NgIf, MatAnchor, MatIcon, DatePipe, TranslateModule, HeadlineWithIconComponent, MatCardContent, AppointmentDetailsComponent, MatButton, MatCardActions, PreventDoubleClickDirective, IconTextComponent, ViessmannHomeBannerComponent, ButtonHeatingSystemsOverviewComponent]
})
export class ProcessedComponent implements OnInit {

  public appointment!: AppointmentModel;
  public settings!: SettingsModel;
  public locale: string | undefined;
  public embedModeEnabled: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService,
    private appointmentService: AppointmentService,
    private embedModeService: EmbedModeService,
    private urlTreeHelper: UrlTreeHelper) {
  }

  ngOnInit() {
    this.appointment = this.route.snapshot.data['appointment'];
    this.settings = this.route.snapshot.data['settings'];
    this.locale = this.translateService.currentLang;
    this.embedModeEnabled = this.embedModeService.isEmbedModeEnabled();

    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.locale = this.translateService.currentLang;
    });

    if (this.appointment.status === 'OPEN') {
      const BASE_PATH = '/' + this.route.snapshot.params['factoryId'] + '/' + this.route.snapshot.params['language'] + '/' + this.route.snapshot.params['id'];
      this.router.navigateByUrl(this.urlTreeHelper.generateUrlTree(
        BASE_PATH, {}));
    } else {
      if (this.appointment) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'appointment_base_information',
          'planUnit': this.appointment.factoryId,
          'customerType': this.appointment.businessPartnerIsEndUser ? "ENDCUSTOMER" : "CUSTOMER",
          'country': this.appointment.country,
          'language': this.appointment.language,
          'status': this.appointment.status,
        });
      }
    }
  }

  closeFrameEvent() {
    this.embedModeService.closeFrameEvent();
  }
}
